import React from 'react';
import FlowCanvas from '@/canvas-editor/FlowCanvas';
import { useTranslation } from 'react-i18next';

const CanvasPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full h-full">
      <FlowCanvas />
    </div>
  );
};

export default CanvasPage;
